import React from "react";
import {
  Card,
  Row,
  Col,
  Button,
  Collapse,
  Form,
  Input,
  Divider,
  Checkbox,
  DatePicker,
} from "antd";
import IntlMessages from "../../../util/IntlMessages";
import { InputGroup } from "reactstrap";
import PersonalTokenImg from "../../../assets/images/personalTokens2.svg";

const AddPersonalTokens = () => {
  const Panel = Collapse.Panel;
  const handleAdd = () => {};

  return (
    <>
      <div className="gx-main-content-wrapper">
        <div>
          <Row>
            <Col md={10}>
              <h1 className="">
                <IntlMessages id="setup.personalTokensTitle" />
              </h1>
            </Col>
            <Col md={14}>
              <div style={{ textAlign: "right", marginBottom: "16px" }}>
                <Button
                  className="custom-btn-addbtn"
                  type="primary"
                  onClick={() => handleAdd()}
                >
                  <strong>
                    <IntlMessages id="setup.personalTokens.generateTokenButton" />
                  </strong>
                </Button>
              </div>
            </Col>
          </Row>
        </div>
        <div>
          <Card className="gx-card" title="">
            <Collapse>
              <Panel
                className="custom-promolist-help"
                showArrow={true}
                header={<IntlMessages id="setup.personalTokens.helpDesc" />}
              >
                <Row>
                  <div className="billing-main">
                    <Col className="custom-promolist-helpdesc" md={12}>
                      <p>
                        <IntlMessages id="setup.personalTokens.helpDescSubText1" />
                      </p>
                      <p>
                        <IntlMessages id="setup.personalTokens.helpDescSubText2" />
                      </p>
                      <p>
                        <IntlMessages id="setup.personalTokens.helpDescSubText3" />
                      </p>
                    </Col>
                    <Col md={12}>
                      <img src={PersonalTokenImg} alt="" />
                    </Col>
                  </div>
                </Row>
              </Panel>
            </Collapse>
          </Card>
        </div>
        <div>
          <Col md={24}>
            <h2 className="add-personal-tokens-header">
              <IntlMessages id="setup.personalTokens.addDetailsTitle" />
            </h2>
            <div className="custom-mg-top-25">
              <Row>
                <Col span={6} md={6} xs={24}>
                  <p className="custom-promolist-helpdesc">
                    <IntlMessages id="setup.personalTokens.addDetailsDesc" />
                  </p>
                </Col>
                <Col span={18} md={14} xs={24}>
                  <Form
                    initialValues={{
                      prefix: "86",
                    }}
                    className="custom-mg-top-26"
                    scrollToFirstError
                    id="PersonalTokenForm"
                    name="PersonalTokenForm"
                  >
                    <InputGroup size="large" className="gx-mb-3">
                      <Form.Item
                        className="ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment"
                        name="TokenName"
                        label={
                          <IntlMessages id="setup.personalTokens.addDetailsInpLab" />
                        }
                        rules={[
                          {
                            required: true,
                            message: (
                              <IntlMessages id="setup.personalTokens.add.name" />
                            ),
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                    </InputGroup>
                  </Form>
                </Col>
              </Row>
            </div>
          </Col>
        </div>
        <Divider className="custom-mgt-mgb-20" />
        <div>
          <Col md={24}>
            <h2 className="add-personal-tokens-header">
              <IntlMessages id="setup.personalTokens.addExpiryTitle" />
            </h2>
          </Col>
          <Row>
            <Col md={6}>
              <p className="custom-promolist-helpdesc">
                <IntlMessages id="setup.personalTokens.addExpiryDesc" />
              </p>
            </Col>
            <Col md={18}>
              <Checkbox
                size="large"
                // onChange={ifPhsycialAddressDifferent}
                //value={isAddressDifferent}
                checked={true}
              >
                <IntlMessages id="setup.personalTokens.allowPersonalCheck" />
              </Checkbox>
              <Col md={14} className="add-token-datepicker">
                <div className="gx-form-row0">
                  <Form.Item
                    className="ant-form-item-label-custom"
                    name={`dateCreatedSearch`}
                    label={
                      <IntlMessages id="setup.personalTokens.expireInpLab" />
                    }
                  >
                    <DatePicker
                      className="gx-mb-3 gx-w-100"
                      size="large"
                      inputReadOnly={true}
                    />
                  </Form.Item>
                </div>
              </Col>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default AddPersonalTokens;
